import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Checkbox,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import UserActions from '@Actions/userActions';
import './style.scss';

const BatchConfiguration = ({
  user, org, updateOrg, updateOrgLoading, getOrg,
}) => {
  const transformData = (batchConfiguration) => {
    const transformedData = [];

    Object.keys(batchConfiguration || {}).map((key) => {
      if (!['is_batch_number_editable', 'restriction'].includes(key)) {
        const fieldName = key.split('_is_')[0];
        const keyName = key.split('_is_')[1];
        const fieldInfo = {
          field_name: fieldName,
          [keyName]: batchConfiguration[key],
        };

        // Check if the field_name already exists in transformedData
        const existingFieldIndex = transformedData.findIndex((item) => item.field_name === fieldName);

        // If the field_name already exists, update its value
        if (existingFieldIndex !== -1) {
          transformedData[existingFieldIndex][keyName] = batchConfiguration[key];
        } else {
          transformedData.push(fieldInfo);
        }
      }
    });

    return transformedData.map((d) => {
      d.field_name = d.field_name.replaceAll('_', ' ');
      d.field_name = d.field_name.toProperCase();
      return d;
    });
  };

  const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
  const [dataSource, setDataSource] = useState(transformData(batchConfig));

  useEffect(() => {
    setDataSource(transformData(batchConfig));
  }, [org]);

  const columns = [
    {
      title: 'Field Name',
      render: (record) => {
        let fieldName = record.field_name;
        if (fieldName === 'Mrp') fieldName = 'MRP';
        if (fieldName === 'Ar Number') fieldName = 'AR Number';
        if (fieldName === 'Next Qc Date') fieldName = 'Next QC Date';
        if (fieldName === 'Last Qc Date') fieldName = 'Last QC Date';
        return (
          <div className="field-name__wrapper">
            {fieldName}
            {record?.system_field ? <H3Text text="SYSTEM" className="system-field" /> : ''}
          </div>
        );
      }

      ,
    },
    {
      title: 'Is Enabled',
      render: (record) => (
        <Checkbox
          checked={batchConfig[`${record?.field_name.toLowerCase().replaceAll(' ', '_')}_is_enabled`]}
          disabled={record?.system_field}
          onChange={(e) => {
            batchConfig[`${record?.field_name.toLowerCase().replaceAll(' ', '_')}_is_enabled`] = e.target.checked;
            if (e.target.checked === false) {
              batchConfig[`${record?.field_name.toLowerCase().replaceAll(' ', '_')}_is_mandatory`] = e.target.checked;
            }
            setDataSource(transformData(batchConfig));
            const payload = {
              org_id: user?.tenant_info?.org_id,
              inventory_config: org?.organisation?.[0]?.inventory_config,
            };
            updateOrg(payload, () => {
              getOrg(user?.tenant_info?.org_id);
              localStorage.removeItem('prcz-page-columns-inventory-lookup');
            });
          }}
        />
      ),
    },
    {
      title: 'Is Mandatory',
      render: (record) => (
        <Checkbox
          checked={record?.mandatory}
          disabled={record?.configuration_disabled}
          onChange={(e) => {
            batchConfig[`${record?.field_name.toLowerCase().replaceAll(' ', '_')}_is_mandatory`] = e.target.checked;
            setDataSource(transformData(batchConfig));
            const payload = {
              org_id: user?.tenant_info?.org_id,
              inventory_config: org?.organisation?.[0]?.inventory_config,
            };
            updateOrg(payload, (data) => {
              getOrg(user?.tenant_info?.org_id);
            });
          }}
        />
      ),
    },
  ];

  return (
    <Fragment>
      <div className="category__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-14">
            <div className="category__table__wrapper">
              <div className="category__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between', 'align-items': 'baseline' }}>
                      Available Inputs
                    </div>
                  )}
                  columns={columns}
                  size="small"
                  scroll="scroll"
                  loading={updateOrgLoading}
                  dataSource={dataSource || []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  updateOrgLoading: UserReducers.updateOrgLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateOrg: (payload, callback) => dispatch(UserActions.updateOrg(payload, callback)),
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchConfiguration));
